export const OTHER_COLONY = 'Mi colonia no aparece';
export const INIT = '0';
export const MEXICO_CITY = 'Ciudad de Mexico';
export const MEXICO_CITY_ACCENT = 'Ciudad de México';
export const COUNTRY_MEXICO = 'MEXICO';
export const COUNTRY_MEXICO_LABEL = 'México';
export const COUNTRY_LABELS: Record<string, string> = {
	MX: 'México',
	US: 'Estados Unidos',
};
export const US_COUNTRY_ID = 'US';
export const ADDRESS_FORM_IDS = {
	exteriorNumberInput: 'exteriorNumberInput',
	exteriorNumberTooltip: 'exteriorNumberTooltip',
	noExteriorNumberCheckbox: 'noExteriorNumberCheckbox',
	interiorNumberInput: 'interiorNumberInput',
};
